import { VideoContainer } from "./Video.styled";
import { motion } from "framer-motion";
import ReactPlayer from "react-player";
import PropTypes from "prop-types";
import useQueueStore from "../../stores/queueStore";
import useNavigateParams from "../../helper/navigateHelper";
import { useLocation } from "react-router-dom";
import { useState, useRef } from "react";
import usePlayListStore from "../../stores/playlistStore";

const Video = ({
  id,
  videoId,
  controls = true,
  muted = false,
  radius = 1,
  playing = true,
}) => {
  const [currentVideoId, setCurrentVideoId] = useState(videoId);
  const [currentId, setCurrentId] = useState(id);
  const [currentPlaying, setCurrentPlaying] = useState(playing);
  const navigate = useNavigateParams();
  const param = useLocation();
  const currentQueues = useQueueStore((state) => state.currentQueues);
  const currentTime = useRef(0);
  const updateQueueStatus = useQueueStore((state) => state.updateQueueStatus);
  const currentPlayingPlaylist = usePlayListStore(
    (state) => state.currentPlayingPlaylist
  );
  const updateCurrentPlayingPlaylistStatus = usePlayListStore(
    (state) => state.updateCurrentPlayingPlaylistStatus
  );

  const onCheckNextSong = () => {
    if (currentQueues.length > 0) {
      const currentItemIndex = currentQueues.findIndex(
        (queue) => queue.id === currentId
      );
      if (currentItemIndex !== -1) {
        // clear current video
        updateQueueStatus(currentItemIndex, false);
        // auto play next video
        if (currentItemIndex + 1 < currentQueues.length) {
          updateQueueStatus(currentItemIndex + 1, true);
          navigate(`${currentQueues[currentItemIndex + 1].videoId}`, {
            q: param.search.slice(3),
          });
          setCurrentVideoId(currentQueues[currentItemIndex + 1].videoId);
          setCurrentId(currentQueues[currentItemIndex + 1].id);
          setCurrentPlaying(currentQueues[currentItemIndex + 1].isPlayingNow);
          if (currentTime.current) {
            currentTime.current = currentTime.current.seekTo(0);
          }
        }
      }
    }

    if (currentPlayingPlaylist) {
      const allVideos = currentPlayingPlaylist.videos;
      if (allVideos) {
        const index = allVideos.findIndex(
          (it) => it.videoId === currentVideoId
        );
        if (index !== -1) {
          // clear current video
          updateCurrentPlayingPlaylistStatus(index, false);
          if (index + 1 < allVideos.length) {
            updateCurrentPlayingPlaylistStatus(index + 1, true);
            navigate(`${allVideos[index + 1].videoId}`, {
              q: param.search.slice(3),
            });
            setCurrentVideoId(allVideos[index + 1].videoId);
            setCurrentPlaying(true);
          }
        }
      }
    }
  };

  const onUpdateQueueStatus = () => {
    if (currentQueues.length > 0) {
      const currentItemIndex = currentQueues.findIndex(
        (queue) => queue.id === currentId
      );
      if (currentItemIndex !== -1) {
        updateQueueStatus(currentItemIndex, true);
      }
    }
  };

  return (
    <VideoContainer
      as={motion.div}
      key={currentVideoId}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{
        duration: 0.5,
      }}
      radius={radius}
    >
      <ReactPlayer
        ref={currentTime}
        url={`https://www.youtube.com/watch?v=${currentVideoId}`}
        playing={currentPlaying}
        width="100%"
        height="100%"
        controls={controls}
        muted={muted}
        onEnded={onCheckNextSong}
        onStart={onUpdateQueueStatus}
      />
    </VideoContainer>
  );
};

Video.propTypes = {
  radius: PropTypes.number,
  controls: PropTypes.bool,
  muted: PropTypes.bool,
  id: PropTypes.string,
};

export default Video;
